export const NOTE_CREATE_REQUEST = 'NOTE_CREATE_REQUEST'
export const NOTE_CREATE_SUCCESS = 'NOTE_CREATE_SUCCESS'
export const NOTE_CREATE_FAIL = 'NOTE_CREATE_FAIL'
export const NOTE_CREATE_RESET = 'NOTE_CREATE_RESET'

export const NOTE_FEED_REQUEST = 'NOTE_FEED_REQUEST'
export const NOTE_FEED_SUCCESS = 'NOTE_FEED_SUCCESS'
export const NOTE_FEED_FAIL = 'NOTE_FEED_FAIL'
export const NOTE_FEED_ADD_SUCCESS = 'NOTE_FEED_ADD_SUCCESS'
export const NOTE_FEED_RESET = 'NOTE_FEED_RESET'

export const NOTE_CUSTOMER_FEED_REQUEST = 'NOTE_CUSTOMER_FEED_REQUEST'
export const NOTE_CUSTOMER_FEED_SUCCESS = 'NOTE_CUSTOMER_FEED_SUCCESS'
export const NOTE_CUSTOMER_FEED_FAIL = 'NOTE_CUSTOMER_FEED_FAIL'
export const NOTE_CUSTOMER_FEED_RESET = 'NOTE_CUSTOMER_FEED_RESET'

export const NOTE_DETAILS_REQUEST = 'NOTE_DETAILS_REQUEST'
export const NOTE_DETAILS_SUCCESS = 'NOTE_DETAILS_SUCCESS'
export const NOTE_DETAILS_FAIL = 'NOTE_DETAILS_FAIL'
export const NOTE_DETAILS_RESET = 'NOTE_DETAILS_RESET'

export const NOTE_FEED_DISABLE_SHOW_MORE = 'NOTE_FEED_DISABLE_SHOW_MORE'
